export {default} from './sh-topics.vue'
